import SectionLabel from "@/components/base/SectionLabel";
import { dxAdvisoryData } from "@/mocks/dxAdvisoryData";

export default function PricingSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="pricing" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-14 md:mb-18 reveal">
          <SectionLabel label={dxAdvisoryData.pricing.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {dxAdvisoryData.pricing.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto items-start">
          {dxAdvisoryData.pricing.plans.map((plan, idx) => (
            <div
              key={plan.name}
              className={`reveal rounded-lg p-6 md:p-7 flex flex-col ${
                plan.isMain
                  ? "bg-primary-500/[0.06] border-2 border-primary-300/60 md:-mt-3 md:pb-9"
                  : "bg-background-50 border border-background-200/70"
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  plan.isMain ? "bg-primary-500" : "bg-primary-100"
                }`}>
                  <i className={`${plan.icon} ${plan.isMain ? "text-background-50" : "text-primary-600"} text-lg`} />
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading">
                  {plan.name}
                </h3>
              </div>

              <div className="mb-4 pb-4 border-b border-background-200/70">
                <p className={`font-bold font-heading ${
                  plan.isMain ? "text-xl md:text-2xl text-primary-600" : "text-base md:text-lg text-foreground-700"
                }`}>
                  {plan.pricing}
                </p>
                {plan.pricingDetail && (
                  <p className="text-xs md:text-sm text-foreground-600 mt-1.5 leading-relaxed">
                    {plan.pricingDetail}
                  </p>
                )}
              </div>

              <ul className="space-y-2 md:space-y-2.5 flex-1 mb-4">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>

              {plan.note && (
                <div className="mt-auto pt-3 border-t border-background-200/70">
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {plan.note}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-12 reveal">
          <button
            onClick={scrollToContact}
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            自社の場合の費用を相談する
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}